import Decimal from 'decimal.js';
import { serviceCostModel, serviceModel } from '~/models';
import { utils } from '~/utils';
export function formatPriceDisplay(cost) {
    if (serviceCostModel.isRangePrice(cost)) {
        const maxPrice = serviceModel.applyDiscount({
            cost
        });
        const minPrice = serviceModel.minPriceFinal({
            cost
        });
        if (maxPrice == null) return undefined;
        return minPrice instanceof Decimal ? "".concat(utils.formatDollarAmount(minPrice), " - ").concat(utils.formatDollarAmount(maxPrice)) : "Up to ".concat(utils.formatDollarAmount(maxPrice));
    }
    const price = serviceModel.finalPrice({
        cost
    }, 1);
    if (price == null) return undefined;
    return price instanceof Decimal ? utils.formatDollarAmount(price) : undefined;
}
